import { useTranslation } from 'react-i18next';

const stats = [
  { value: '50K+', label: 'stats.orders', color: 'text-rose-500' },
  { value: '40%', label: 'stats.savings', color: 'text-emerald-500' },
  { value: '35+', label: 'stats.countries', color: 'text-amber-500' },
  { value: '4.9', label: 'stats.rating', color: 'text-sky-500' },
];

export default function StatsSection() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-white py-16 md:py-24 overflow-hidden">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.03]">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20pattern%20with%20very%20subtle%20product%20silhouettes%2C%20ultra%20light%20beige%20background%2C%20barely%20visible%20iconic%20fashion%20items%20shadow%20pattern%2C%20clean%20seamless%20texture%2C%20high%20contrast%20subtle%20design&width=800&height=800&seq=stats-texture-01&orientation=squarish"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 w-full px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row">
          {/* Left content */}
          <div className="lg:w-[70%] lg:pr-12">
            <h2 className="font-heading text-3xl md:text-4xl font-medium text-stone-900 leading-tight max-w-xl">
              {t('stats.title')}
            </h2>

            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0">
              {stats.map((stat, index) => (
                <div
                  key={stat.label}
                  className={`text-center md:text-left ${
                    index < stats.length - 1 ? 'md:border-r md:border-stone-200' : ''
                  } md:px-6 first:md:pl-0`}
                >
                  <span className={`font-heading text-4xl md:text-5xl font-bold ${stat.color}`}>
                    {stat.value}
                  </span>
                  <p className="mt-2 text-sm text-stone-500 leading-snug">
                    {t(stat.label)}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right decorative - product collage */}
          <div className="lg:w-[30%] mt-10 lg:mt-0 relative overflow-hidden rounded-2xl min-h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20product%20flat%20lay%20collage%20with%20sneakers%20leather%20goods%20accessories%20on%20soft%20beige%20background%2C%20organized%20chaotic%20arrangement%2C%20editorial%20fashion%20photography%2C%20warm%20lighting%2C%20creative%20composition%20with%20negative%20space&width=600&height=600&seq=stats-collage-01&orientation=squarish"
              alt="YOYBUY products collage"
              className="absolute inset-0 w-full h-full object-cover"
            />
            {/* Subtle overlay for readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-white/40 via-transparent to-transparent" />
            {/* Stats badge overlay */}
            <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-xl">
              <p className="text-xs font-semibold text-stone-900">YOYBUY Spreadsheet</p>
              <p className="text-xs text-stone-500">#1 выбор 2026</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}